import Swiper from 'swiper/bundle';
document.addEventListener('DOMContentLoaded', () => {
    const commonConfig = {
        speed: 1200,
    };
    const swiperLeftConfig = {
        ...commonConfig,
        direction: "vertical",
        slidesPerView: 1,
        allowTouchMove: false,
    };
    const swiperRightConfig = {
        ...commonConfig,
        direction: "horizontal",
        slidesPerView: 1,
        spaceBetween: 40,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
            formatFractionCurrent: (number) => number < 10 ? '0' + number : number,
            formatFractionTotal: (number) => number < 10 ? '0' + number : number,
            renderFraction: (currentClass, totalClass) =>
                `<span class="${currentClass}"></span> / <span class="${totalClass}"></span>`,
        },
    };
    const swiperLeft = new Swiper(".about-us-left", swiperLeftConfig);
    const swiperRight = new Swiper(".swiper-about-right", swiperRightConfig);
    swiperLeft.controller.control = swiperRight;
    swiperRight.controller.control = swiperLeft;
});
